import { render, staticRenderFns } from "./ques10.vue?vue&type=template&id=5f9d3692"
import script from "./ques10.vue?vue&type=script&lang=js"
export * from "./ques10.vue?vue&type=script&lang=js"
import style0 from "./ques10.vue?vue&type=style&index=0&id=5f9d3692&prod&lang=css"
import style1 from "./ques10.vue?vue&type=style&index=1&id=5f9d3692&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports